import { instance } from 'api/core';
import { CallbackObject } from 'api/core/get-page-function';
import { AxiosResponse } from 'axios';
import { plainToClass } from 'class-transformer';
import { GetProductBatchesVm } from './get-product-batches.vm';

export const getProductBatches = async (
  productId: string,
  term: string | null,
  offset: string,
  limit: number,
  callback: CallbackObject<GetProductBatchesVm>
) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: limit ?? 50,
      offset: offset,
    },
  };

  if (term) {
    config.params.term = term;
  }

  try {
    const res: AxiosResponse = await instance.get(`/catalog/products/${productId}/batches`, config);
    callback.success(plainToClass(GetProductBatchesVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
